import { render, staticRenderFns } from "./DadosPessoais.vue?vue&type=template&id=ec786956&"
import script from "./DadosPessoais.vue?vue&type=script&lang=js&"
export * from "./DadosPessoais.vue?vue&type=script&lang=js&"
import style0 from "./DadosPessoais.vue?vue&type=style&index=0&id=ec786956&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports